import type * as Sentry from "@sentry/nextjs";

type SentryOptions = Parameters<typeof Sentry.init>[0];

export const SENTRY_DATA_COLLECTION: NonNullable<SentryOptions["dataCollection"]> = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: false,
    response: false,
  },
  httpBodies: [],
  urlQueryParams: false,
  graphQL: {
    document: false,
    variables: false,
  },
  genAI: {
    inputs: false,
    outputs: false,
  },
  databaseQueryData: false,
  stackFrameVariables: false,
};

export function getSentryEnvironment() {
  return process.env.NEXT_PUBLIC_APP_ENV ?? "development";
}
